// extracted by mini-css-extract-plugin
export var alt = "SiteOffers-module--alt--d5aa8";
export var container = "SiteOffers-module--container--1d9f7";
export var containerSm = "SiteOffers-module--container-sm--85b86";
export var desktopOnly = "SiteOffers-module--desktopOnly--8e803";
export var main = "SiteOffers-module--main--0fccc";
export var mobileOnly = "SiteOffers-module--mobileOnly--b518d";
export var styledContainer = "SiteOffers-module--styledContainer--ee45a";
export var subTitle = "SiteOffers-module--subTitle--6a135";
export var textLeft = "SiteOffers-module--textLeft--b83dc";
export var visuallyHidden = "SiteOffers-module--visuallyHidden--05d5f";